<!--Template CCV -->
<template>
    <li v-if="hub === 'hub_devis'">
        <a v-if=" inFrance && (ccv === '1')"
           title="Rappel gratuit" v-on:click="showModal()" :categorie="categorie"
           :libelle="libelle" :pe="pe" action="Callback" :valeur="valeur" class="btn_wcb_on BT_ACTION">
            <figure>
                <svg width="50" height="50" viewBox="0 0 50 50" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M6.86842 11.2402L11.9421 6.04492C12.3 5.67648 12.7254 5.38415 13.1938 5.18472C13.6623 4.98529 14.1646 4.88269 14.6719 4.88281C15.7056 4.88281 16.6775 5.29785 17.4064 6.04492L22.8659 11.6406C23.2254 12.0075 23.5106 12.4435 23.7052 12.9236C23.8998 13.4037 23.9999 13.9186 23.9998 14.4385C23.9998 15.498 23.5948 16.4941 22.8659 17.2412L18.8737 21.333C19.8082 23.4441 21.1074 25.3647 22.7087 27.002C24.306 28.6472 26.1797 29.9837 28.2397 30.9473L32.232 26.8555C32.5899 26.487 33.0153 26.1947 33.4837 25.9953C33.9522 25.7958 34.4545 25.6932 34.9617 25.6934C35.9955 25.6934 36.9674 26.1084 37.6963 26.8555L43.1606 32.4463C43.5205 32.8138 43.806 33.2506 44.0006 33.7316C44.1952 34.2126 44.295 34.7283 44.2944 35.249C44.2944 36.3086 43.8895 37.3047 43.1606 38.0518L38.0965 43.2422C36.934 44.4385 35.3286 45.1172 33.6802 45.1172C33.3325 45.1172 32.999 45.0879 32.6703 45.0293C26.2484 43.9453 19.8789 40.4443 14.7386 35.1807C9.60296 29.9219 6.19193 23.3984 5.12003 16.7969C4.79608 14.7803 5.44875 12.7051 6.86842 11.2402V11.2402Z"
                        fill="currentColor"/>
                </svg>
                <figcaption>
                    <span>Je souhaite <u class="text-primary">être appelé</u></span>
                    <span class="block font-10">au numéro de mon choix</span>
                </figcaption>
            </figure>
        </a>
        <a v-else-if="inFrance"
           :href="route"
           :categorie="categorie"
           :pe="pe"
           :libelle="libelle"
           :action="action"
           :valeur="valeur"
           title="" class="btn_wcb_on BT_ACTION">
            <figure>
                <svg width="50" height="50" viewBox="0 0 50 50" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M6.86842 11.2402L11.9421 6.04492C12.3 5.67648 12.7254 5.38415 13.1938 5.18472C13.6623 4.98529 14.1646 4.88269 14.6719 4.88281C15.7056 4.88281 16.6775 5.29785 17.4064 6.04492L22.8659 11.6406C23.2254 12.0075 23.5106 12.4435 23.7052 12.9236C23.8998 13.4037 23.9999 13.9186 23.9998 14.4385C23.9998 15.498 23.5948 16.4941 22.8659 17.2412L18.8737 21.333C19.8082 23.4441 21.1074 25.3647 22.7087 27.002C24.306 28.6472 26.1797 29.9837 28.2397 30.9473L32.232 26.8555C32.5899 26.487 33.0153 26.1947 33.4837 25.9953C33.9522 25.7958 34.4545 25.6932 34.9617 25.6934C35.9955 25.6934 36.9674 26.1084 37.6963 26.8555L43.1606 32.4463C43.5205 32.8138 43.806 33.2506 44.0006 33.7316C44.1952 34.2126 44.295 34.7283 44.2944 35.249C44.2944 36.3086 43.8895 37.3047 43.1606 38.0518L38.0965 43.2422C36.934 44.4385 35.3286 45.1172 33.6802 45.1172C33.3325 45.1172 32.999 45.0879 32.6703 45.0293C26.2484 43.9453 19.8789 40.4443 14.7386 35.1807C9.60296 29.9219 6.19193 23.3984 5.12003 16.7969C4.79608 14.7803 5.44875 12.7051 6.86842 11.2402V11.2402Z"
                        fill="currentColor"/>
                </svg>
                <figcaption>
                    <span>Je souhaite être appelé</span>
                    <span class="block font-10">Disponible du lundi au vendredi de 8h30 à 18h</span>
                </figcaption>
            </figure>
        </a>
    </li>
    <!--Template DOA -->
    <div v-else-if="simuTarifaire || pe === 'PE_Gestion_Vie_GSP'">
        <div v-if=" inFrance && (ccv === '1')">
            <a v-if="link === 'href'" v-on:click="showModal()" v-on:keyup.enter="showModal()" :categorie="categorie"
               tabindex="0"
               :libelle="libelle" :pe="pe" action="Callback" :valeur="valeur"
               :class="ccvclass">
            <span class="app-button-text">
                {{ title || 'Je souhaite être appelé' }}</span></a>
            <button type="button" v-if="link === 'button'" v-on:click="showModal()" v-on:keyup.enter="showModal()"
                    :categorie="categorie" tabindex="0"
                    :libelle="libelle" :pe="pe" action="Callback" :valeur="valeur"
                    :class="ccvclass">
            <span class="app-button-text">
                {{ title || 'Je souhaite être appelé' }}</span></button>
        </div>
        <div v-else-if="title && inFrance">
            <div>
                <a v-if="link === 'href'"
                   class=""
                   :class="ccvclass"
                   :href="routeSticky"
                   :categorie="analytics.categorie"
                   :pe="pe"
                   :libelle="analytics.libelle"
                   :action="analytics.action"
                   :valeur="analytics.valeur"
                >
            <span class="app-button-text">
                {{ titleSticky }}
            </span>
                </a>
                <button v-else-if="link === 'button'" type="button"
                        class=""
                        :class="css?css:'flex justify-content-center bt-color--primary'"
                        :href="routeSticky"
                        :categorie="analytics.categorie"
                        :pe="pe"
                        :libelle="analytics.libelle"
                        :action="analytics.action"
                        :valeur="analytics.valeur"
                >
            <span class="app-button-text">
                {{ titleSticky }}
            </span>
                </button>
            </div>
        </div>
    </div>
    <div v-else>
        <div v-if=" inFrance && (ccv === '1')">
            <a v-on:click="showModal()" :categorie="categorie"
               :libelle="libelle" :pe="pe" action="Callback" :valeur="valeur"
               class="app-button w-100 mt-3 LnkWcbForm-trigger LnkWcbForm-trigger-button BT_ACTION">

                <span class="app-button-text">{{ title || 'Je souhaite être appelé' }}</span></a>
        </div>
        <div v-else-if="title && inFrance">
            <a
                class="app-button mt-3 app-button-devis"
                :class=" (type) ? 'app-button-' + type + ' ' + css : css "
                :href=" inFrance ? route : routeSticky"
                :categorie="analytics.categorie"
                :pe="pe"
                :libelle="analytics.libelle"
                :action="inFrance ? action : analytics.action"
                :valeur="analytics.valeur"
            >
            <span class="app-button-text">
                {{ inFrance ? title : titleSticky }}
            </span>
            </a>
        </div>
    </div>
</template>

<script>
import WebCallBackIsiComComponent from "./WebCallBackIsiComComponent";

export default {
    name: "WebCallBackBoutonComponent",
    components: {WebCallBackIsiComComponent},
    props: {
        "categorie": {type: String},
        "pe": {type: String, default: "Tego_CCV_webcallback"},
        "link": {type: String, default: "href"},
        "hub": {type: String, default: "other"},
        "libelle": {type: String},
        "ccv": {type: String},
        "title": {type: String},
        "type": {type: String},
        "css": {type: String},
        "analytics": {type: Object, default: {}},
        "route": {type: String},
        "routeSticky": {type: String},
        "titleSticky": {type: String},
        "action": {type: String},
        "valeur": {type: String},
        "ccvclass": {
            type: String,
            default: "app-button w-100 mt-3 LnkWcbForm-trigger LnkWcbForm-trigger-button BT_ACTION"
        },
        "simuTarifaire": {
            type: Boolean,
            default: false
        }
    },
    computed: {
        inFrance: function () {
            return (Intl.DateTimeFormat().resolvedOptions().timeZone === 'Europe/Paris');
        }
    },
    methods: {
        showModal() {
            this.$root.$emit('openModal', this.categorie, this.pe);
            this.$root.$emit('addValeur', this.valeur + '€');
        }
    }
}
</script>

<style scoped>

</style>
